import { render, staticRenderFns } from "./pricesSimpleTable.vue?vue&type=template&id=05c475a8&scoped=true"
import script from "./pricesSimpleTable.vue?vue&type=script&lang=js"
export * from "./pricesSimpleTable.vue?vue&type=script&lang=js"
import style0 from "./pricesSimpleTable.vue?vue&type=style&index=0&id=05c475a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c475a8",
  null
  
)

export default component.exports